<app-type-lotsMAPA id="step4" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [lots]="initial.lots" [alloti]="initial.isAlloti"
></app-type-lotsMAPA>


